import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
    store_id: null,
    pred_date: [],
    graph_setting: null,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};